'use strict';
const n = (a, e, t) => {
  const r = new URLSearchParams(a.toString());
  return r.set(e, t), r;
}, s = (a, e, t) => {
  const r = new URLSearchParams(a.toString());
  return r.append(e, t), r;
}, o = (a, e, t) => {
  const r = new URLSearchParams(a.toString());
  return r.delete(e, t), r;
};
export {
  s as appendQueryParam,
  o as removeQueryParam,
  n as setQueryParam
};
